import Vue from 'vue';
//@ts-ignore
import store from './store';
import App from './App.vue';
import router from './router/index';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import ClassicEditor from './assets/js/ckeditor/ckeditor5-build-inline'
//@ts-ignore;
import pdfComponents from './utils/html2pdf';
import ScoreBox from './components/common/score-box';
import TopicEditBox from './components/common/edit-box';
import IntegerInput from './components/common/integer-input';
import MyUEditor from './components/common/ueditor';
import Pagination from "./components/Pagination.vue"
import './utils/savePageData';
// import './assets/css/common.scss';
import "./assets/css/main.scss";
import "./assets/css/base.scss";
import "./assets/css/spacing.scss"; // 小间距模式
//@ts-ignore
//@ts-ignore
// import jquery from 'jquery'
// Vue.prototype.$JQ = jquery;
Vue.use(ScoreBox);
Vue.use(MyUEditor);
Vue.use(TopicEditBox);
Vue.use(IntegerInput);
Vue.component('Pagination', Pagination)
Vue.use(ElementUI);
Vue.use(pdfComponents);
Vue.config.productionTip = false; //阻止你显示显示生产模式的消息
//@ts-ignore
ElementUI.Dialog.props.closeOnClickModal.default = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
